import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";

export async function loadSeecDocument(docId) {
  const snap = await getDoc(doc(db, "SEEC", docId));
  if (!snap.exists()) return null;

  const baseData = snap.data();
  if (!baseData?.chunkedData || !Array.isArray(baseData.dataChunkDocIds)) {
    return { id: snap.id, ...baseData };
  }

  const chunkSnaps = await Promise.all(
    baseData.dataChunkDocIds.map((chunkDocId) => getDoc(doc(db, "SEEC", chunkDocId)))
  );

  const chunkRows = chunkSnaps
    .filter((chunkSnap) => chunkSnap.exists())
    .sort((a, b) => {
      const aIndex = a.data()?.chunkIndex ?? 0;
      const bIndex = b.data()?.chunkIndex ?? 0;
      return aIndex - bIndex;
    })
    .flatMap((chunkSnap) => chunkSnap.data()?.data || []);

  return {
    id: snap.id,
    ...baseData,
    data: chunkRows,
  };
}

export async function loadSeecDocuments(docIds = []) {
  const docs = await Promise.all(docIds.map((docId) => loadSeecDocument(docId)));
  return docs.filter(Boolean);
}
